module.exports = __webpack_public_path__ + "media/reskin-images/icon--eye-fcedeef5.svg";